export const GET_SESSION_DETAIL_NAME = "get_session_detail";
export const GET_SESSION_DETAIL_DESC =
  "Get the GA4 session details for a specific user and session in User Analytics. You must include the `sessionExplorerUrl` link in your response to the user.";
